<template>
    <div class="section">
        <div class="container is-fluid">
            <div class="columns">
                <div class="column">
                    <h1 class="title has-text-centered">Tools</h1>
                </div>
            </div>
            <div class="columns">
                <div class="column is-one-third">
                    <inland-calculator v-if="isAdmin"></inland-calculator>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InlandCalculator from './Calculators/InlandCalculator.vue'
    export default {
        components: {
            InlandCalculator
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            }
        }
    }
</script>

<style scoped>
    .title {
        margin-top: 25px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Tools/Tools.vue